"use client";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function Sidebar() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const checkMobileView = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    // Menambahkan event listener untuk resize window
    checkMobileView(); // Memeriksa langsung ketika komponen dimuat
    window.addEventListener("resize", checkMobileView);

    // Membersihkan event listener ketika komponen dibersihkan
    return () => {
      window.removeEventListener("resize", checkMobileView);
    };
  }, []);

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("image_url");
    Cookies.remove("email");

    navigate("/");

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    localStorage.clear(); // Menghapus semua data di localStorage
    sessionStorage.clear(); // Menghapus semua data di sessionStorage

    window.location.reload();
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      {isMobile && (
        <>
          {isSidebarOpen ? (
            <button
              className="fixed top-18 left-0 pr-1 z-20 md:hidden text-xl text-slate-400 hover:text-indigo-800 bg-slate-200 hover:bg-indigo-200 hover:left-0 hover:pl-4 transition-all duration-300 rounded-md max-sm:mt-[72px]"
              onClick={toggleSidebar}
              aria-label="Toggle Sidebar"
            >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
          ) : (
            <button
              className="fixed left-0 pr-7  z-20 md:hidden text-xl text-slate-400 hover:text-indigo-800 bg-slate-200 hover:bg-indigo-200 hover:pl-4 hover:pr-3 hover:left-0 transition-all duration-300 rounded-md max-sm:mt-[72px]"
              onClick={toggleSidebar}
              aria-label="Toggle Sidebar"
            >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          )}

          {isSidebarOpen ? (
            <aside className="overflow-hidden pt-5 shadow-md bg-slate-50 min-h-screen w-[300px] max-md:w-[250px] max-sm:w-[200px] fixed left-0 top-[70px] z-10">
              <div className="flex flex-col w-full">
                <nav className="flex flex-col justify-center mt-5 w-full">
                  <ul className="w-full leading-relaxed">
                    <Link
                      to={"/dashboard"}
                      className="flex gap-2 items-center justify-start text-sm font-medium text-slate-500 whitespace-nowrap group"
                    >
                      <div className="flex gap-2 items-center self-stretch py-3 px-4 group-hover:bg-violet-100 w-full rounded-md group-hover:text-indigo-600">
                        <div>
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 10 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_1941)">
                              <path
                                d="M2.49159 5.46641H1.70825L5.23325 1.94141L8.75825 5.46641H7.97492"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M2.49146 5.4668V8.20846C2.49146 8.41622 2.57398 8.61546 2.72089 8.76236C2.86779 8.90927 3.06704 8.9918 3.27479 8.9918H7.19145C7.39921 8.9918 7.59845 8.90927 7.74536 8.76236C7.89226 8.61546 7.97479 8.41622 7.97479 8.20846V5.4668"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_1941">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533203 0.766602)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>

                        <span className="flex-1 shrink basis-0">Dashboard</span>
                      </div>
                    </Link>

                    <Link
                      to={"/dashboard/list-job-vacancy"}
                      className="flex gap-2 items-center py-3 pr-4 pl-4 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1569_1974)">
                            <path
                              d="M4.05837 2.92529H3.27503C3.06728 2.92529 2.86804 3.00782 2.72113 3.15473C2.57423 3.30163 2.4917 3.50087 2.4917 3.70863V8.40863C2.4917 8.61638 2.57423 8.81562 2.72113 8.96253C2.86804 9.10943 3.06728 9.19196 3.27503 9.19196H7.1917C7.39945 9.19196 7.5987 9.10943 7.7456 8.96253C7.8925 8.81562 7.97503 8.61638 7.97503 8.40863V3.70863C7.97503 3.50087 7.8925 3.30163 7.7456 3.15473C7.5987 3.00782 7.39945 2.92529 7.1917 2.92529H6.40837"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.62502 2.1416H4.84168C4.40906 2.1416 4.05835 2.49231 4.05835 2.92493C4.05835 3.35756 4.40906 3.70827 4.84168 3.70827H5.62502C6.05764 3.70827 6.40835 3.35756 6.40835 2.92493C6.40835 2.49231 6.05764 2.1416 5.62502 2.1416Z"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M4.05835 5.66699H4.06227"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.625 5.66699H6.40833"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M4.05835 7.2334H4.06227"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.625 7.2334H6.40833"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1569_1974">
                              <rect
                                width="9.4"
                                height="9.4"
                                fill="white"
                                transform="translate(0.533447 0.966797)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <span className="flex-1 shrink basis-0">
                        Job Listing Table
                      </span>
                    </Link>

                    <Link
                      to={"/dashboard/list-job-vacancy/form"}
                      className="flex gap-2 items-center py-3 pr-3 pl-5 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="17"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 4.5H14V3.5C14 2.70435 13.6839 1.94129 13.1213 1.37868C12.5587 0.816071 11.7956 0.5 11 0.5H9C8.20435 0.5 7.44129 0.816071 6.87868 1.37868C6.31607 1.94129 6 2.70435 6 3.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.316071 5.94129 0 6.70435 0 7.5V16.5C0 17.2956 0.316071 18.0587 0.87868 18.6213C1.44129 19.1839 2.20435 19.5 3 19.5H17C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5V7.5C20 6.70435 19.6839 5.94129 19.1213 5.37868C18.5587 4.81607 17.7956 4.5 17 4.5ZM8 3.5C8 3.23478 8.10536 2.98043 8.29289 2.79289C8.48043 2.60536 8.73478 2.5 9 2.5H11C11.2652 2.5 11.5196 2.60536 11.7071 2.79289C11.8946 2.98043 12 3.23478 12 3.5V4.5H8V3.5ZM18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5H3C2.73478 17.5 2.48043 17.3946 2.29289 17.2071C2.10536 17.0196 2 16.7652 2 16.5V11C4.54626 12.0101 7.26069 12.5293 10 12.53C12.7392 12.5283 15.4535 12.0092 18 11V16.5ZM18 8.81C15.4784 9.91778 12.7542 10.4898 10 10.4898C7.24579 10.4898 4.5216 9.91778 2 8.81V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H17C17.2652 6.5 17.5196 6.60536 17.7071 6.79289C17.8946 6.98043 18 7.23478 18 7.5V8.81Z"
                            fill="#7C8493"
                            className="group-hover:fill-indigo-600"
                          />
                        </svg>
                      </div>
                      <span className="flex-1 pl-1">Add new Job</span>
                    </Link>
                  </ul>

                  <div className="flex mt-5 w-full bg-indigo-200 min-h-px" />
                  <div className="flex flex-col mt-4 w-full">
                    <h3 className="flex gap-2 items-start self-start pl-4 text-xs font-semibold tracking-wide leading-loose text-gray-800 whitespace-nowrap">
                      <span className="opacity-50">SETTINGS</span>
                    </h3>
                    <ul className="mt-3 w-full text-sm font-medium leading-relaxed text-slate-500">
                      <Link
                        to={"/dashboard/profile"}
                        className="flex gap-2 items-center py-3 pr-3 pl-5 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                      >
                        <div>
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.71 10.7096C14.6904 9.9383 15.406 8.88056 15.7572 7.68358C16.1085 6.4866 16.0779 5.2099 15.6698 4.0311C15.2617 2.85231 14.4963 1.83003 13.4801 1.10649C12.4639 0.382955 11.2474 -0.00585937 10 -0.00585938C8.75255 -0.00585938 7.53611 0.382955 6.51993 1.10649C5.50374 1.83003 4.73834 2.85231 4.33021 4.0311C3.92208 5.2099 3.89151 6.4866 4.24276 7.68358C4.59401 8.88056 5.3096 9.9383 6.29 10.7096C4.61007 11.3827 3.14428 12.499 2.04889 13.9396C0.953495 15.3801 0.26956 17.0909 0.0699967 18.8896C0.0555513 19.021 0.0671132 19.1538 0.104022 19.2807C0.140931 19.4075 0.202464 19.5259 0.285108 19.629C0.452016 19.8371 0.69478 19.9705 0.959997 19.9996C1.22521 20.0288 1.49116 19.9514 1.69932 19.7845C1.90749 19.6176 2.04082 19.3749 2.07 19.1096C2.28958 17.1548 3.22168 15.3494 4.68822 14.0384C6.15475 12.7274 8.0529 12.0027 10.02 12.0027C11.9871 12.0027 13.8852 12.7274 15.3518 14.0384C16.8183 15.3494 17.7504 17.1548 17.97 19.1096C17.9972 19.3554 18.1144 19.5823 18.2991 19.7467C18.4838 19.911 18.7228 20.0011 18.97 19.9996H19.08C19.3421 19.9695 19.5817 19.8369 19.7466 19.6309C19.9114 19.4248 19.9881 19.162 19.96 18.8996C19.7595 17.0958 19.0719 15.3806 17.9708 13.9378C16.8698 12.4951 15.3969 11.3791 13.71 10.7096ZM10 9.99964C9.20887 9.99964 8.43551 9.76504 7.77772 9.32551C7.11992 8.88599 6.60723 8.26128 6.30448 7.53037C6.00173 6.79947 5.92251 5.9952 6.07686 5.21928C6.2312 4.44335 6.61216 3.73062 7.17157 3.17121C7.73098 2.6118 8.44371 2.23084 9.21964 2.0765C9.99556 1.92215 10.7998 2.00137 11.5307 2.30412C12.2616 2.60687 12.8863 3.11956 13.3259 3.77736C13.7654 4.43515 14 5.20851 14 5.99964C14 7.0605 13.5786 8.07792 12.8284 8.82806C12.0783 9.57821 11.0609 9.99964 10 9.99964Z"
                              fill="#7C8493"
                              className="group-hover:fill-indigo-600"
                            />
                          </svg>
                        </div>
                        <span className="flex-1 pl-1">Profile</span>
                      </Link>
                      <Link
                        to={"/dashboard/change-password"}
                        className="flex gap-2 items-center py-3 pr-3 pl-4 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                      >
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_1999)">
                              <path
                                d="M4.57745 2.11543C4.7443 1.42767 5.72269 1.42767 5.88954 2.11543C5.91457 2.21876 5.96365 2.31471 6.03277 2.39548C6.1019 2.47625 6.18912 2.53955 6.28733 2.58024C6.38555 2.62093 6.49199 2.63786 6.59798 2.62964C6.70397 2.62142 6.80653 2.58829 6.8973 2.53295C7.50164 2.16478 8.19371 2.85647 7.82555 3.4612C7.77028 3.55193 7.7372 3.65442 7.72901 3.76035C7.72081 3.86627 7.73772 3.97263 7.77836 4.07078C7.819 4.16894 7.88224 4.25612 7.96291 4.32524C8.04359 4.39436 8.13944 4.44346 8.24267 4.46857C8.93044 4.63542 8.93044 5.6138 8.24267 5.78065C8.13935 5.80569 8.0434 5.85476 7.96263 5.92389C7.88186 5.99301 7.81855 6.08023 7.77786 6.17845C7.73717 6.27666 7.72025 6.3831 7.72846 6.48909C7.73668 6.59508 7.76981 6.69764 7.82515 6.78841C8.19332 7.39275 7.50164 8.08483 6.8969 7.71666C6.80617 7.66139 6.70368 7.62832 6.59776 7.62012C6.49184 7.61192 6.38548 7.62883 6.28732 7.66947C6.18917 7.71012 6.10199 7.77335 6.03287 7.85403C5.96375 7.93471 5.91464 8.03056 5.88954 8.13378C5.72269 8.82155 4.7443 8.82155 4.57745 8.13378C4.55242 8.03046 4.50334 7.93451 4.43422 7.85374C4.36509 7.77297 4.27787 7.70967 4.17966 7.66898C4.08144 7.62828 3.97501 7.61136 3.86901 7.61958C3.76302 7.62779 3.66047 7.66092 3.5697 7.71627C2.96535 8.08443 2.27328 7.39275 2.64145 6.78802C2.69671 6.69729 2.72979 6.59479 2.73799 6.48887C2.74618 6.38295 2.72927 6.27659 2.68863 6.17844C2.64799 6.08028 2.58476 5.9931 2.50408 5.92398C2.4234 5.85486 2.32755 5.80575 2.22432 5.78065C1.53655 5.6138 1.53655 4.63542 2.22432 4.46857C2.32764 4.44353 2.42359 4.39446 2.50436 4.32533C2.58513 4.25621 2.64844 4.16899 2.68913 4.07077C2.72982 3.97256 2.74675 3.86612 2.73853 3.76013C2.73031 3.65413 2.69718 3.55158 2.64184 3.46081C2.27367 2.85647 2.96535 2.16439 3.57009 2.53256C3.96019 2.77069 4.46935 2.55998 4.57745 2.11543Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M6.40835 5.1252C6.40835 5.43682 6.28456 5.73569 6.0642 5.95605C5.84384 6.1764 5.54498 6.3002 5.23335 6.3002C4.92172 6.3002 4.62285 6.1764 4.4025 5.95605C4.18214 5.73569 4.05835 5.43682 4.05835 5.1252C4.05835 4.81357 4.18214 4.5147 4.4025 4.29434C4.62285 4.07399 4.92172 3.9502 5.23335 3.9502C5.54498 3.9502 5.84384 4.07399 6.0642 4.29434C6.28456 4.5147 6.40835 4.81357 6.40835 5.1252V5.1252Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_1999">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533447 0.424805)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span className="flex-1">Change Password</span>
                      </Link>

                      <li className="flex gap-2 items-center py-3 pr-3 pl-4 w-full hover:bg-violet-100 group hover:text-indigo-600">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_2004)">
                              <path
                                d="M5.2335 8.44941C7.1803 8.44941 8.7585 6.87122 8.7585 4.92441C8.7585 2.97761 7.1803 1.39941 5.2335 1.39941C3.28669 1.39941 1.7085 2.97761 1.7085 4.92441C1.7085 6.87122 3.28669 8.44941 5.2335 8.44941Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M5.2334 6.88281V6.88673"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M5.23353 5.51207C5.22632 5.38492 5.26062 5.25888 5.33126 5.15291C5.4019 5.04695 5.50506 4.96681 5.6252 4.92457C5.77241 4.86827 5.90455 4.77857 6.01121 4.66253C6.11787 4.54648 6.19613 4.40726 6.23985 4.25583C6.28356 4.1044 6.29152 3.94489 6.26311 3.78986C6.2347 3.63482 6.1707 3.4885 6.07613 3.36241C5.98156 3.23632 5.85901 3.1339 5.71814 3.06322C5.57726 2.99254 5.4219 2.95552 5.26428 2.95508C5.10667 2.95464 4.95111 2.9908 4.80984 3.0607C4.66857 3.1306 4.54546 3.23234 4.4502 3.3579"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_2004">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533447 0.224609)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span className="flex-1">Help Center</span>
                      </li>
                      <button
                        className="flex gap-2 items-center py-3 pr-52 pl-5 w-full hover:bg-violet-100 group hover:text-indigo-600"
                        onClick={handleLogout}
                      >
                        <div>
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 16 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z"
                              fill="#7C8493"
                              className="group-hover:fill-indigo-600"
                            />
                          </svg>
                        </div>
                        <span className="flex-1 pl-1">Logout</span>
                      </button>
                    </ul>
                  </div>
                </nav>
              </div>
            </aside>
          ) : (
            <aside className="overflow-hidden pt-5 shadow-md bg-slate-50 min-h-screen w-[300px] max-md:w-[250px] max-sm:w-[60px] fixed left-0 top-[70px] z-10 ">
              <div className="flex flex-col w-full">
                <nav className="flex flex-col justify-center mt-5 w-full">
                  <ul className="w-full leading-relaxed">
                    <Link
                      to={"/dashboard"}
                      className="flex gap-2 items-center justify-start text-sm font-medium text-slate-500 whitespace-nowrap group"
                    >
                      <div className="flex gap-2 items-center self-stretch py-3 px-4 group-hover:bg-violet-100 w-full rounded-md group-hover:text-indigo-600">
                        <div>
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 10 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_1941)">
                              <path
                                d="M2.49159 5.46641H1.70825L5.23325 1.94141L8.75825 5.46641H7.97492"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M2.49146 5.4668V8.20846C2.49146 8.41622 2.57398 8.61546 2.72089 8.76236C2.86779 8.90927 3.06704 8.9918 3.27479 8.9918H7.19145C7.39921 8.9918 7.59845 8.90927 7.74536 8.76236C7.89226 8.61546 7.97479 8.41622 7.97479 8.20846V5.4668"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_1941">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533203 0.766602)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                    </Link>

                    <Link
                      to={"/dashboard/list-job-vacancy"}
                      className="flex gap-2 items-center py-3 pr-4 pl-4 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1569_1974)">
                            <path
                              d="M4.05837 2.92529H3.27503C3.06728 2.92529 2.86804 3.00782 2.72113 3.15473C2.57423 3.30163 2.4917 3.50087 2.4917 3.70863V8.40863C2.4917 8.61638 2.57423 8.81562 2.72113 8.96253C2.86804 9.10943 3.06728 9.19196 3.27503 9.19196H7.1917C7.39945 9.19196 7.5987 9.10943 7.7456 8.96253C7.8925 8.81562 7.97503 8.61638 7.97503 8.40863V3.70863C7.97503 3.50087 7.8925 3.30163 7.7456 3.15473C7.5987 3.00782 7.39945 2.92529 7.1917 2.92529H6.40837"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.62502 2.1416H4.84168C4.40906 2.1416 4.05835 2.49231 4.05835 2.92493C4.05835 3.35756 4.40906 3.70827 4.84168 3.70827H5.62502C6.05764 3.70827 6.40835 3.35756 6.40835 2.92493C6.40835 2.49231 6.05764 2.1416 5.62502 2.1416Z"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M4.05835 5.66699H4.06227"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.625 5.66699H6.40833"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M4.05835 7.2334H4.06227"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.625 7.2334H6.40833"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1569_1974">
                              <rect
                                width="9.4"
                                height="9.4"
                                fill="white"
                                transform="translate(0.533447 0.966797)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </Link>

                    <Link
                      to={"/dashboard/list-job-vacancy/form"}
                      className="flex gap-2 items-center py-3 pr-3 pl-5 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="17"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 4.5H14V3.5C14 2.70435 13.6839 1.94129 13.1213 1.37868C12.5587 0.816071 11.7956 0.5 11 0.5H9C8.20435 0.5 7.44129 0.816071 6.87868 1.37868C6.31607 1.94129 6 2.70435 6 3.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.316071 5.94129 0 6.70435 0 7.5V16.5C0 17.2956 0.316071 18.0587 0.87868 18.6213C1.44129 19.1839 2.20435 19.5 3 19.5H17C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5V7.5C20 6.70435 19.6839 5.94129 19.1213 5.37868C18.5587 4.81607 17.7956 4.5 17 4.5ZM8 3.5C8 3.23478 8.10536 2.98043 8.29289 2.79289C8.48043 2.60536 8.73478 2.5 9 2.5H11C11.2652 2.5 11.5196 2.60536 11.7071 2.79289C11.8946 2.98043 12 3.23478 12 3.5V4.5H8V3.5ZM18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5H3C2.73478 17.5 2.48043 17.3946 2.29289 17.2071C2.10536 17.0196 2 16.7652 2 16.5V11C4.54626 12.0101 7.26069 12.5293 10 12.53C12.7392 12.5283 15.4535 12.0092 18 11V16.5ZM18 8.81C15.4784 9.91778 12.7542 10.4898 10 10.4898C7.24579 10.4898 4.5216 9.91778 2 8.81V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H17C17.2652 6.5 17.5196 6.60536 17.7071 6.79289C17.8946 6.98043 18 7.23478 18 7.5V8.81Z"
                            fill="#7C8493"
                            className="group-hover:fill-indigo-600"
                          />
                        </svg>
                      </div>
                    </Link>
                  </ul>

                  <div className="flex mt-5 w-full bg-indigo-200 min-h-px" />
                  <div className="flex flex-col mt-4 w-full">
                    <h3 className="flex gap-2 items-start self-start pl-4 text-xs font-semibold tracking-wide leading-loose text-gray-800 whitespace-nowrap">
                      <span className="opacity-50"></span>
                    </h3>
                    <ul className="mt-3 w-full text-sm font-medium leading-relaxed text-slate-500">
                      <Link
                        to={"/dashboard/profile"}
                        className="flex gap-2 items-center py-3 pr-3 pl-5 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                      >
                        <div>
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.71 10.7096C14.6904 9.9383 15.406 8.88056 15.7572 7.68358C16.1085 6.4866 16.0779 5.2099 15.6698 4.0311C15.2617 2.85231 14.4963 1.83003 13.4801 1.10649C12.4639 0.382955 11.2474 -0.00585937 10 -0.00585938C8.75255 -0.00585938 7.53611 0.382955 6.51993 1.10649C5.50374 1.83003 4.73834 2.85231 4.33021 4.0311C3.92208 5.2099 3.89151 6.4866 4.24276 7.68358C4.59401 8.88056 5.3096 9.9383 6.29 10.7096C4.61007 11.3827 3.14428 12.499 2.04889 13.9396C0.953495 15.3801 0.26956 17.0909 0.0699967 18.8896C0.0555513 19.021 0.0671132 19.1538 0.104022 19.2807C0.140931 19.4075 0.202464 19.5259 0.285108 19.629C0.452016 19.8371 0.69478 19.9705 0.959997 19.9996C1.22521 20.0288 1.49116 19.9514 1.69932 19.7845C1.90749 19.6176 2.04082 19.3749 2.07 19.1096C2.28958 17.1548 3.22168 15.3494 4.68822 14.0384C6.15475 12.7274 8.0529 12.0027 10.02 12.0027C11.9871 12.0027 13.8852 12.7274 15.3518 14.0384C16.8183 15.3494 17.7504 17.1548 17.97 19.1096C17.9972 19.3554 18.1144 19.5823 18.2991 19.7467C18.4838 19.911 18.7228 20.0011 18.97 19.9996H19.08C19.3421 19.9695 19.5817 19.8369 19.7466 19.6309C19.9114 19.4248 19.9881 19.162 19.96 18.8996C19.7595 17.0958 19.0719 15.3806 17.9708 13.9378C16.8698 12.4951 15.3969 11.3791 13.71 10.7096ZM10 9.99964C9.20887 9.99964 8.43551 9.76504 7.77772 9.32551C7.11992 8.88599 6.60723 8.26128 6.30448 7.53037C6.00173 6.79947 5.92251 5.9952 6.07686 5.21928C6.2312 4.44335 6.61216 3.73062 7.17157 3.17121C7.73098 2.6118 8.44371 2.23084 9.21964 2.0765C9.99556 1.92215 10.7998 2.00137 11.5307 2.30412C12.2616 2.60687 12.8863 3.11956 13.3259 3.77736C13.7654 4.43515 14 5.20851 14 5.99964C14 7.0605 13.5786 8.07792 12.8284 8.82806C12.0783 9.57821 11.0609 9.99964 10 9.99964Z"
                              fill="#7C8493"
                              className="group-hover:fill-indigo-600"
                            />
                          </svg>
                        </div>
                      </Link>
                      <Link
                        to={"/dashboard/change-password"}
                        className="flex gap-2 items-center py-3 pr-3 pl-4 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                      >
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_1999)">
                              <path
                                d="M4.57745 2.11543C4.7443 1.42767 5.72269 1.42767 5.88954 2.11543C5.91457 2.21876 5.96365 2.31471 6.03277 2.39548C6.1019 2.47625 6.18912 2.53955 6.28733 2.58024C6.38555 2.62093 6.49199 2.63786 6.59798 2.62964C6.70397 2.62142 6.80653 2.58829 6.8973 2.53295C7.50164 2.16478 8.19371 2.85647 7.82555 3.4612C7.77028 3.55193 7.7372 3.65442 7.72901 3.76035C7.72081 3.86627 7.73772 3.97263 7.77836 4.07078C7.819 4.16894 7.88224 4.25612 7.96291 4.32524C8.04359 4.39436 8.13944 4.44346 8.24267 4.46857C8.93044 4.63542 8.93044 5.6138 8.24267 5.78065C8.13935 5.80569 8.0434 5.85476 7.96263 5.92389C7.88186 5.99301 7.81855 6.08023 7.77786 6.17845C7.73717 6.27666 7.72025 6.3831 7.72846 6.48909C7.73668 6.59508 7.76981 6.69764 7.82515 6.78841C8.19332 7.39275 7.50164 8.08483 6.8969 7.71666C6.80617 7.66139 6.70368 7.62832 6.59776 7.62012C6.49184 7.61192 6.38548 7.62883 6.28732 7.66947C6.18917 7.71012 6.10199 7.77335 6.03287 7.85403C5.96375 7.93471 5.91464 8.03056 5.88954 8.13378C5.72269 8.82155 4.7443 8.82155 4.57745 8.13378C4.55242 8.03046 4.50334 7.93451 4.43422 7.85374C4.36509 7.77297 4.27787 7.70967 4.17966 7.66898C4.08144 7.62828 3.97501 7.61136 3.86901 7.61958C3.76302 7.62779 3.66047 7.66092 3.5697 7.71627C2.96535 8.08443 2.27328 7.39275 2.64145 6.78802C2.69671 6.69729 2.72979 6.59479 2.73799 6.48887C2.74618 6.38295 2.72927 6.27659 2.68863 6.17844C2.64799 6.08028 2.58476 5.9931 2.50408 5.92398C2.4234 5.85486 2.32755 5.80575 2.22432 5.78065C1.53655 5.6138 1.53655 4.63542 2.22432 4.46857C2.32764 4.44353 2.42359 4.39446 2.50436 4.32533C2.58513 4.25621 2.64844 4.16899 2.68913 4.07077C2.72982 3.97256 2.74675 3.86612 2.73853 3.76013C2.73031 3.65413 2.69718 3.55158 2.64184 3.46081C2.27367 2.85647 2.96535 2.16439 3.57009 2.53256C3.96019 2.77069 4.46935 2.55998 4.57745 2.11543Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M6.40835 5.1252C6.40835 5.43682 6.28456 5.73569 6.0642 5.95605C5.84384 6.1764 5.54498 6.3002 5.23335 6.3002C4.92172 6.3002 4.62285 6.1764 4.4025 5.95605C4.18214 5.73569 4.05835 5.43682 4.05835 5.1252C4.05835 4.81357 4.18214 4.5147 4.4025 4.29434C4.62285 4.07399 4.92172 3.9502 5.23335 3.9502C5.54498 3.9502 5.84384 4.07399 6.0642 4.29434C6.28456 4.5147 6.40835 4.81357 6.40835 5.1252V5.1252Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_1999">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533447 0.424805)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </Link>

                      <li className="flex gap-2 items-center py-3 pr-3 pl-4 w-full hover:bg-violet-100 group hover:text-indigo-600">
                        <div>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 10 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1569_2004)">
                              <path
                                d="M5.2335 8.44941C7.1803 8.44941 8.7585 6.87122 8.7585 4.92441C8.7585 2.97761 7.1803 1.39941 5.2335 1.39941C3.28669 1.39941 1.7085 2.97761 1.7085 4.92441C1.7085 6.87122 3.28669 8.44941 5.2335 8.44941Z"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M5.2334 6.88281V6.88673"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                              <path
                                d="M5.23353 5.51207C5.22632 5.38492 5.26062 5.25888 5.33126 5.15291C5.4019 5.04695 5.50506 4.96681 5.6252 4.92457C5.77241 4.86827 5.90455 4.77857 6.01121 4.66253C6.11787 4.54648 6.19613 4.40726 6.23985 4.25583C6.28356 4.1044 6.29152 3.94489 6.26311 3.78986C6.2347 3.63482 6.1707 3.4885 6.07613 3.36241C5.98156 3.23632 5.85901 3.1339 5.71814 3.06322C5.57726 2.99254 5.4219 2.95552 5.26428 2.95508C5.10667 2.95464 4.95111 2.9908 4.80984 3.0607C4.66857 3.1306 4.54546 3.23234 4.4502 3.3579"
                                stroke="#7C8493"
                                strokeWidth="0.783333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="group-hover:stroke-indigo-600"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1569_2004">
                                <rect
                                  width="9.4"
                                  height="9.4"
                                  fill="white"
                                  transform="translate(0.533447 0.224609)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </li>
                      <button
                        className="flex gap-2 items-center py-3 pr-52 pl-5 w-full hover:bg-violet-100 group hover:text-indigo-600"
                        onClick={handleLogout}
                      >
                        <div>
                          <svg
                            width="18"
                            height="20"
                            viewBox="0 0 16 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z"
                              fill="#7C8493"
                              className="group-hover:fill-indigo-600"
                            />
                          </svg>
                        </div>
                      </button>
                    </ul>
                  </div>
                </nav>
              </div>
            </aside>
          )}
        </>
      )}

      {!isMobile && (
        <>
          <aside className="overflow-hidden pt-5 shadow-md bg-slate-50 min-h-screen w-[300px] max-md:w-[250px] max-sm:w-[200px] fixed left-0 top-[70px] z-10">
            <div className="flex flex-col w-full">
              <nav className="flex flex-col justify-center mt-5 w-full">
                <ul className="w-full leading-relaxed">
                  <Link
                    to={"/dashboard"}
                    className="flex gap-2 items-center justify-start text-sm font-medium text-slate-500 whitespace-nowrap group"
                  >
                    <div className="flex gap-2 items-center self-stretch py-3 px-4 group-hover:bg-violet-100 w-full rounded-md group-hover:text-indigo-600">
                      <div>
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 10 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1569_1941)">
                            <path
                              d="M2.49159 5.46641H1.70825L5.23325 1.94141L8.75825 5.46641H7.97492"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M2.49146 5.4668V8.20846C2.49146 8.41622 2.57398 8.61546 2.72089 8.76236C2.86779 8.90927 3.06704 8.9918 3.27479 8.9918H7.19145C7.39921 8.9918 7.59845 8.90927 7.74536 8.76236C7.89226 8.61546 7.97479 8.41622 7.97479 8.20846V5.4668"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1569_1941">
                              <rect
                                width="9.4"
                                height="9.4"
                                fill="white"
                                transform="translate(0.533203 0.766602)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <span className="flex-1 shrink basis-0">Dashboard</span>
                    </div>
                  </Link>

                  <Link
                    to={"/dashboard/list-job-vacancy"}
                    className="flex gap-2 items-center py-3 pr-4 pl-4 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                  >
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 10 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1569_1974)">
                          <path
                            d="M4.05837 2.92529H3.27503C3.06728 2.92529 2.86804 3.00782 2.72113 3.15473C2.57423 3.30163 2.4917 3.50087 2.4917 3.70863V8.40863C2.4917 8.61638 2.57423 8.81562 2.72113 8.96253C2.86804 9.10943 3.06728 9.19196 3.27503 9.19196H7.1917C7.39945 9.19196 7.5987 9.10943 7.7456 8.96253C7.8925 8.81562 7.97503 8.61638 7.97503 8.40863V3.70863C7.97503 3.50087 7.8925 3.30163 7.7456 3.15473C7.5987 3.00782 7.39945 2.92529 7.1917 2.92529H6.40837"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                          <path
                            d="M5.62502 2.1416H4.84168C4.40906 2.1416 4.05835 2.49231 4.05835 2.92493C4.05835 3.35756 4.40906 3.70827 4.84168 3.70827H5.62502C6.05764 3.70827 6.40835 3.35756 6.40835 2.92493C6.40835 2.49231 6.05764 2.1416 5.62502 2.1416Z"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                          <path
                            d="M4.05835 5.66699H4.06227"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                          <path
                            d="M5.625 5.66699H6.40833"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                          <path
                            d="M4.05835 7.2334H4.06227"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                          <path
                            d="M5.625 7.2334H6.40833"
                            stroke="#7C8493"
                            strokeWidth="0.783333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="group-hover:stroke-indigo-600"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1569_1974">
                            <rect
                              width="9.4"
                              height="9.4"
                              fill="white"
                              transform="translate(0.533447 0.966797)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <span className="flex-1 shrink basis-0">
                      Job Listing Table
                    </span>
                  </Link>

                  <Link
                    to={"/dashboard/list-job-vacancy/form"}
                    className="flex gap-2 items-center py-3 pr-3 pl-5 w-full text-sm font-medium text-slate-500 hover:bg-violet-100 group hover:text-indigo-600"
                  >
                    <div>
                      <svg
                        width="17"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 4.5H14V3.5C14 2.70435 13.6839 1.94129 13.1213 1.37868C12.5587 0.816071 11.7956 0.5 11 0.5H9C8.20435 0.5 7.44129 0.816071 6.87868 1.37868C6.31607 1.94129 6 2.70435 6 3.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.316071 5.94129 0 6.70435 0 7.5V16.5C0 17.2956 0.316071 18.0587 0.87868 18.6213C1.44129 19.1839 2.20435 19.5 3 19.5H17C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5V7.5C20 6.70435 19.6839 5.94129 19.1213 5.37868C18.5587 4.81607 17.7956 4.5 17 4.5ZM8 3.5C8 3.23478 8.10536 2.98043 8.29289 2.79289C8.48043 2.60536 8.73478 2.5 9 2.5H11C11.2652 2.5 11.5196 2.60536 11.7071 2.79289C11.8946 2.98043 12 3.23478 12 3.5V4.5H8V3.5ZM18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5H3C2.73478 17.5 2.48043 17.3946 2.29289 17.2071C2.10536 17.0196 2 16.7652 2 16.5V11C4.54626 12.0101 7.26069 12.5293 10 12.53C12.7392 12.5283 15.4535 12.0092 18 11V16.5ZM18 8.81C15.4784 9.91778 12.7542 10.4898 10 10.4898C7.24579 10.4898 4.5216 9.91778 2 8.81V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H17C17.2652 6.5 17.5196 6.60536 17.7071 6.79289C17.8946 6.98043 18 7.23478 18 7.5V8.81Z"
                          fill="#7C8493"
                          className="group-hover:fill-indigo-600"
                        />
                      </svg>
                    </div>
                    <span className="flex-1 pl-1">Add new Job</span>
                  </Link>
                </ul>

                <div className="flex mt-5 w-full bg-indigo-200 min-h-px" />
                <div className="flex flex-col mt-4 w-full">
                  <h3 className="flex gap-2 items-start self-start pl-4 text-xs font-semibold tracking-wide leading-loose text-gray-800 whitespace-nowrap">
                    <span className="opacity-50">SETTINGS</span>
                  </h3>
                  <ul className="mt-3 w-full text-sm font-medium leading-relaxed text-slate-500">
                    <Link
                      to={"/dashboard/profile"}
                      className="flex gap-2 items-center py-3 pr-3 pl-5 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="18"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.71 10.7096C14.6904 9.9383 15.406 8.88056 15.7572 7.68358C16.1085 6.4866 16.0779 5.2099 15.6698 4.0311C15.2617 2.85231 14.4963 1.83003 13.4801 1.10649C12.4639 0.382955 11.2474 -0.00585937 10 -0.00585938C8.75255 -0.00585938 7.53611 0.382955 6.51993 1.10649C5.50374 1.83003 4.73834 2.85231 4.33021 4.0311C3.92208 5.2099 3.89151 6.4866 4.24276 7.68358C4.59401 8.88056 5.3096 9.9383 6.29 10.7096C4.61007 11.3827 3.14428 12.499 2.04889 13.9396C0.953495 15.3801 0.26956 17.0909 0.0699967 18.8896C0.0555513 19.021 0.0671132 19.1538 0.104022 19.2807C0.140931 19.4075 0.202464 19.5259 0.285108 19.629C0.452016 19.8371 0.69478 19.9705 0.959997 19.9996C1.22521 20.0288 1.49116 19.9514 1.69932 19.7845C1.90749 19.6176 2.04082 19.3749 2.07 19.1096C2.28958 17.1548 3.22168 15.3494 4.68822 14.0384C6.15475 12.7274 8.0529 12.0027 10.02 12.0027C11.9871 12.0027 13.8852 12.7274 15.3518 14.0384C16.8183 15.3494 17.7504 17.1548 17.97 19.1096C17.9972 19.3554 18.1144 19.5823 18.2991 19.7467C18.4838 19.911 18.7228 20.0011 18.97 19.9996H19.08C19.3421 19.9695 19.5817 19.8369 19.7466 19.6309C19.9114 19.4248 19.9881 19.162 19.96 18.8996C19.7595 17.0958 19.0719 15.3806 17.9708 13.9378C16.8698 12.4951 15.3969 11.3791 13.71 10.7096ZM10 9.99964C9.20887 9.99964 8.43551 9.76504 7.77772 9.32551C7.11992 8.88599 6.60723 8.26128 6.30448 7.53037C6.00173 6.79947 5.92251 5.9952 6.07686 5.21928C6.2312 4.44335 6.61216 3.73062 7.17157 3.17121C7.73098 2.6118 8.44371 2.23084 9.21964 2.0765C9.99556 1.92215 10.7998 2.00137 11.5307 2.30412C12.2616 2.60687 12.8863 3.11956 13.3259 3.77736C13.7654 4.43515 14 5.20851 14 5.99964C14 7.0605 13.5786 8.07792 12.8284 8.82806C12.0783 9.57821 11.0609 9.99964 10 9.99964Z"
                            fill="#7C8493"
                            className="group-hover:fill-indigo-600"
                          />
                        </svg>
                      </div>
                      <span className="flex-1 pl-1">Profile</span>
                    </Link>
                    <Link
                      to={"/dashboard/change-password"}
                      className="flex gap-2 items-center py-3 pr-3 pl-4 w-full whitespace-nowrap hover:bg-violet-100 group hover:text-indigo-600"
                    >
                      <div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1569_1999)">
                            <path
                              d="M4.57745 2.11543C4.7443 1.42767 5.72269 1.42767 5.88954 2.11543C5.91457 2.21876 5.96365 2.31471 6.03277 2.39548C6.1019 2.47625 6.18912 2.53955 6.28733 2.58024C6.38555 2.62093 6.49199 2.63786 6.59798 2.62964C6.70397 2.62142 6.80653 2.58829 6.8973 2.53295C7.50164 2.16478 8.19371 2.85647 7.82555 3.4612C7.77028 3.55193 7.7372 3.65442 7.72901 3.76035C7.72081 3.86627 7.73772 3.97263 7.77836 4.07078C7.819 4.16894 7.88224 4.25612 7.96291 4.32524C8.04359 4.39436 8.13944 4.44346 8.24267 4.46857C8.93044 4.63542 8.93044 5.6138 8.24267 5.78065C8.13935 5.80569 8.0434 5.85476 7.96263 5.92389C7.88186 5.99301 7.81855 6.08023 7.77786 6.17845C7.73717 6.27666 7.72025 6.3831 7.72846 6.48909C7.73668 6.59508 7.76981 6.69764 7.82515 6.78841C8.19332 7.39275 7.50164 8.08483 6.8969 7.71666C6.80617 7.66139 6.70368 7.62832 6.59776 7.62012C6.49184 7.61192 6.38548 7.62883 6.28732 7.66947C6.18917 7.71012 6.10199 7.77335 6.03287 7.85403C5.96375 7.93471 5.91464 8.03056 5.88954 8.13378C5.72269 8.82155 4.7443 8.82155 4.57745 8.13378C4.55242 8.03046 4.50334 7.93451 4.43422 7.85374C4.36509 7.77297 4.27787 7.70967 4.17966 7.66898C4.08144 7.62828 3.97501 7.61136 3.86901 7.61958C3.76302 7.62779 3.66047 7.66092 3.5697 7.71627C2.96535 8.08443 2.27328 7.39275 2.64145 6.78802C2.69671 6.69729 2.72979 6.59479 2.73799 6.48887C2.74618 6.38295 2.72927 6.27659 2.68863 6.17844C2.64799 6.08028 2.58476 5.9931 2.50408 5.92398C2.4234 5.85486 2.32755 5.80575 2.22432 5.78065C1.53655 5.6138 1.53655 4.63542 2.22432 4.46857C2.32764 4.44353 2.42359 4.39446 2.50436 4.32533C2.58513 4.25621 2.64844 4.16899 2.68913 4.07077C2.72982 3.97256 2.74675 3.86612 2.73853 3.76013C2.73031 3.65413 2.69718 3.55158 2.64184 3.46081C2.27367 2.85647 2.96535 2.16439 3.57009 2.53256C3.96019 2.77069 4.46935 2.55998 4.57745 2.11543Z"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M6.40835 5.1252C6.40835 5.43682 6.28456 5.73569 6.0642 5.95605C5.84384 6.1764 5.54498 6.3002 5.23335 6.3002C4.92172 6.3002 4.62285 6.1764 4.4025 5.95605C4.18214 5.73569 4.05835 5.43682 4.05835 5.1252C4.05835 4.81357 4.18214 4.5147 4.4025 4.29434C4.62285 4.07399 4.92172 3.9502 5.23335 3.9502C5.54498 3.9502 5.84384 4.07399 6.0642 4.29434C6.28456 4.5147 6.40835 4.81357 6.40835 5.1252V5.1252Z"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1569_1999">
                              <rect
                                width="9.4"
                                height="9.4"
                                fill="white"
                                transform="translate(0.533447 0.424805)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <span className="flex-1">Change Password</span>
                    </Link>

                    <li className="flex gap-2 items-center py-3 pr-3 pl-4 w-full hover:bg-violet-100 group hover:text-indigo-600">
                      <div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 10 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1569_2004)">
                            <path
                              d="M5.2335 8.44941C7.1803 8.44941 8.7585 6.87122 8.7585 4.92441C8.7585 2.97761 7.1803 1.39941 5.2335 1.39941C3.28669 1.39941 1.7085 2.97761 1.7085 4.92441C1.7085 6.87122 3.28669 8.44941 5.2335 8.44941Z"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.2334 6.88281V6.88673"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                            <path
                              d="M5.23353 5.51207C5.22632 5.38492 5.26062 5.25888 5.33126 5.15291C5.4019 5.04695 5.50506 4.96681 5.6252 4.92457C5.77241 4.86827 5.90455 4.77857 6.01121 4.66253C6.11787 4.54648 6.19613 4.40726 6.23985 4.25583C6.28356 4.1044 6.29152 3.94489 6.26311 3.78986C6.2347 3.63482 6.1707 3.4885 6.07613 3.36241C5.98156 3.23632 5.85901 3.1339 5.71814 3.06322C5.57726 2.99254 5.4219 2.95552 5.26428 2.95508C5.10667 2.95464 4.95111 2.9908 4.80984 3.0607C4.66857 3.1306 4.54546 3.23234 4.4502 3.3579"
                              stroke="#7C8493"
                              strokeWidth="0.783333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="group-hover:stroke-indigo-600"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1569_2004">
                              <rect
                                width="9.4"
                                height="9.4"
                                fill="white"
                                transform="translate(0.533447 0.224609)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <span className="flex-1">Help Center</span>
                    </li>
                    <button
                      className="flex gap-2 items-center py-3 pr-52 pl-5 w-full hover:bg-violet-100 group hover:text-indigo-600"
                      onClick={handleLogout}
                    >
                      <div>
                        <svg
                          width="18"
                          height="20"
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z"
                            fill="#7C8493"
                            className="group-hover:fill-indigo-600"
                          />
                        </svg>
                      </div>
                      <span className="flex-1 pl-1">Logout</span>
                    </button>
                  </ul>
                </div>
              </nav>
            </div>
          </aside>
        </>
      )}
    </>
  );
}

export default Sidebar;
